import { Plus, Trash2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { RULE_HI } from "@/lib/aiot";

const SLOTS = [["trigger", "triggers", "WHEN", "जब", "#1D4ED8"], ["condition", "conditions", "AND", "और", "#B45309"], ["action", "actions", "THEN", "तब", "#059669"]];

export const useRuleLabel = (lab) => {
  const { lang } = useLang();
  const all = Object.fromEntries(Object.values(lab.rule_options).flat());
  return (k) => (lang === "hi" ? RULE_HI[k] || all[k] : all[k]) || k;
};

export const RulePanel = ({ lab, rules, setRules }) => {
  const { L, lang } = useLang();
  const label = useRuleLabel(lab);
  const set = (i, k, v) => setRules(rules.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div data-testid="lab-rule-panel">
      <p className="text-sm text-slate-600">{L("Write the automation rules. Every scenario on the Test tab must behave correctly, including the ones where nothing should happen.", "ऑटोमेशन रूल लिखिए। टेस्ट टैब का हर सीनारियो सही चलना चाहिए, उनमें भी जहाँ कुछ नहीं होना चाहिए।")}</p>
      <details className="mt-3 rounded-xl border border-slate-200 bg-white p-3" data-testid="lab-rule-scenarios">
        <summary className="text-sm font-bold text-[#0B1F3A] cursor-pointer">{L(`Situations to handle (${lab.scenarios.length})`, `संभालने वाली स्थितियाँ (${lab.scenarios.length})`)}</summary>
        <ul className="mt-2 space-y-2">
          {lab.scenarios.map((s) => (
            <li key={s.id} className="text-xs text-slate-700">
              <span className="font-semibold">{lang === "hi" ? s.hi : s.en}</span>
              <span className="block mt-0.5 text-[10px] text-slate-500">{label(s.trigger)} · {s.facts.map(label).join(" · ")}</span>
            </li>
          ))}
        </ul>
      </details>
      <div className="mt-3 space-y-3">
        {rules.map((r, i) => (
          <div key={i} className="rounded-2xl border border-slate-200 bg-white p-3" data-testid={`lab-rule-${i}`}>
            <div className="flex items-center justify-between"><span className="text-xs font-black text-slate-400">{L("Rule", "रूल")} {i + 1}</span>
              <button type="button" onClick={() => setRules(rules.filter((_, j) => j !== i))} className="p-1 rounded hover:bg-slate-100 text-slate-500" aria-label="Delete rule" data-testid={`lab-rule-delete-${i}`}><Trash2 className="w-4 h-4" /></button>
            </div>
            <div className="mt-2 grid gap-2">
              {SLOTS.map(([k, list, en, hi, c]) => (
                <label key={k} className="flex items-center gap-2">
                  <span className="w-12 text-[11px] font-black tracking-wide" style={{ color: c }}>{L(en, hi)}</span>
                  <select value={r[k] || ""} onChange={(e) => set(i, k, e.target.value)} className="flex-1 rounded-lg border-2 px-2 py-1.5 text-sm bg-white" style={{ borderColor: c }} data-testid={`lab-rule-${i}-${k}`}>
                    <option value="">{L("choose…", "चुनें…")}</option>
                    {lab.rule_options[list].map(([key]) => <option key={key} value={key}>{label(key)}</option>)}
                  </select>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button type="button" disabled={rules.length >= 12} onClick={() => setRules([...rules, { trigger: "", condition: "always", action: "" }])} className="mt-3 w-full h-10 rounded-full border-2 border-dashed border-slate-300 text-sm font-bold text-[#0F766E] inline-flex items-center justify-center gap-1.5 hover:border-[#0F766E] disabled:opacity-40" data-testid="lab-rule-add">
        <Plus className="w-4 h-4" />{L("Add rule", "रूल जोड़ें")}
      </button>
    </div>
  );
};
